import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material';
import { ActivatedRoute, Router } from '@angular/router';
import { ListadoDocentesDto } from 'src/app/dto/listado-docentes-dto';
import { CursoService } from 'src/app/services/curso.service';
import { PersonaService } from 'src/app/services/persona.service';
import { CuestionarioComponent } from '../cuestionario/cuestionario.component';
import { EvaluadosDto } from 'src/app/dto/evaluados-dto';
import { EvaluacionService } from 'src/app/services/evaluacion.service';
import Swal from 'sweetalert2';
import { EvaluadosComponent } from '../evaluados/evaluados.component';

@Component({
  selector: 'app-estudiante',
  templateUrl: './estudiante.component.html',
  styleUrls: ['./estudiante.component.css']
})
export class EstudianteComponent implements OnInit {

  arr: ListadoDocentesDto[];
  arrNuevo: ListadoDocentesDto[];
  periodo: string;
  url: String = 'https://gaitana.usco.edu.co/evadoc';
  grupoUid: number;
  evaluados: EvaluadosDto[];
  expandedIndex = 1;

  constructor(
    private router: Router,
    private cursoService: CursoService,
    private personaService: PersonaService,
    public dialog: MatDialog,
    private rutaActiva: ActivatedRoute,
    private evaluacionService: EvaluacionService
  ) { }

  ngOnInit() {
    this.obtenerCursos();
    this.grupoUid = this.rutaActiva.snapshot.params.grupo;
  }

  obtenerCursos() {
    this.cursoService.obtenerCursos().subscribe((data) => {
      this.arr = data || []; // Asegurarse de que siempre haya un array

      this.arr.forEach(curso => {
        curso.docentes = curso.docentes || []; // Asegurarse de que siempre haya un array de docentes
        this.docentesEvaluados(this.arr, curso.cusros.curso.codigo);
      });

      this.obtenerPeriodo();
    });
  }

  obtenerPeriodo() {
    this.personaService.getPeriodo(this.arr[0].cusros.curso.calendario.periodo.codigo).subscribe(data => {
      this.periodo = data;
    })
  }

  openDialog(docentes: number, cursos: number, id: number) {
    const dialogRef = this.dialog.open(CuestionarioComponent, {
      maxWidth: '95vw',
      width: '950px',
      maxHeight: '90vh',
      disableClose: true,
      data: {
        uid: this.grupoUid,
        periodo: this.arr[0].cusros.curso.calendario.periodo.codigo,
        docente: docentes,
        curso: this.arr != null ? cursos : null,
      },
    });

    dialogRef.afterClosed().subscribe(result => {
      this.docentesEvaluados(this.arr, cursos);
      // Recalcular qué panel debe estar habilitado y expandido después de la evaluación
      this.getNextToEvaluateId();
    });
  }

  docentesEvaluados(arreg: ListadoDocentesDto[], cursoCodigoEvaluado: number): void {
    const tipo = 1;
    const periodo = this.arr[0].cusros.curso.calendario.periodo.codigo;

    this.cursoService.ObtenerEvaluados(tipo, periodo).subscribe((data) => {
      this.evaluados = data;

      // Validar si todos los docentes de todos los cursos han sido evaluados
      const allEvaluated = this.arr.every(cursoDto =>
        cursoDto.docentes.every(docente =>
          this.isDocenteEvaluado(docente.codigo, cursoDto.cusros.curso.codigo)
        )
      );

      // Actualizar el estado en tiempo real
      this.evaluacionService.setDocentesEvaluados(allEvaluated);
    });
  }


  isDocenteEvaluado(docenteCodigo: number, cursoCodigo: number): boolean {
    if (!this.evaluados || !this.evaluados.length) {
      return false; // Si no hay evaluados, ningún docente ha sido evaluado
    }

    return this.evaluados.some(evaluado =>
      evaluado.docente === docenteCodigo && evaluado.curso === cursoCodigo
    );
  }

  DialogDocente() {
    // Verificar que both evaluados y docentesEvaluados son arrays y no están vacíos
    if (Array.isArray(this.evaluados) && this.evaluados.length > 0 ||
      Array.isArray(this.docentesEvaluados) && this.docentesEvaluados.length > 0) {

      const isMobile = window.innerWidth < 768;
      const dialogRef = this.dialog.open(EvaluadosComponent, {
        maxWidth: '95vw',
        width: isMobile ? '95%' : '80%',
        data: {
          Listaevaluados: this.evaluados,
          //Evaluados: this.docentesEvaluados
        },
      });

      dialogRef.afterClosed().subscribe(result => {
        // Aquí puedes manejar el resultado del diálogo si es necesario
      });
    } else {
      Swal.fire({
        icon: 'warning',
        title: '¡Docentes no evaluados!',
        confirmButtonColor: '#5C0E12',
        confirmButtonText: 'Aceptar',
        showClass: {
          popup: 'animate__animated animate__fadeInDown'
        },
        hideClass: {
          popup: 'animate__animated animate__fadeOutUp'
        }
      });
    }
  }

  shouldEnablePanel(item: ListadoDocentesDto, cursoCodigoEvaluado: number): boolean {
    // Habilitar si el curso actual es el que se evaluó
    if (item.cusros.curso.codigo === cursoCodigoEvaluado) {
      return true;
    }

    // Deshabilitar solo si todos los docentes de este curso específico han sido evaluados
    return item.docentes.some(docente => !this.isDocenteEvaluado(docente.codigo, item.cusros.curso.codigo));
  }

  getNextToEvaluateId(): number {
    // Si no hay docentes evaluados aún, habilitar el primer panel
    if (!this.evaluados || this.evaluados.length === 0) {
      return 0;
    }

    // Buscar el primer curso donde haya docentes que aún no hayan sido evaluados
    for (let i = 0; i < this.arr.length; i++) {
      const docentesNoEvaluados = this.arr[i].docentes.filter(docente => !this.isDocenteEvaluado(docente.codigo, this.arr[i].cusros.curso.codigo));

      if (docentesNoEvaluados.length > 0) {
        return i; // Devolver el índice del primer curso con docentes no evaluados
      }
    }

    // Si todos los docentes están evaluados, devolver un índice inválido (-1)
    return -1;
  }

}
